import { getAction } from "@/api/manage";
import QrCode from "@/components/tools/QrCode";
export default {
  name: "CertQuery",
  components: {
    QrCode: QrCode
  },
  data: function data() {
    return {
      awardInfo: {},
      awardCode: "",
      fileUrl: ''
    };
  },
  created: function created() {
    var id = this.$route.query.id;
    var awardCode = this.$route.query.code;
    if (id || awardCode) {
      this.getAwardInfo(id, awardCode);
    }
    // if(window.location.pathname == "/cert/query"){
    //   window.location.href = "/cert/query.html" + window.location.search
    // }
  },
  methods: {
    onSearch: function onSearch(awardCode) {
      this.getAwardInfo(undefined, awardCode);
    },
    getAwardInfo: function getAwardInfo(id, awardCode) {
      var _this = this;
      this.awardInfo = {};
      getAction("/teaching/teachingAwardGrant/queryAward", {
        id: id,
        awardCode: awardCode
      }).then(function (res) {
        if (res.success) {
          _this.awardInfo = res.result;
          _this.fileUrl = res.result.awardFile_url + "?t=" + new Date().getTime();
        } else {
          _this.$message.error(res.message);
        }
      });
    }
  }
};